import React from 'react'
import { Box, Grid, Typography } from '@mui/material/'
import { Theme } from '@mui/material/styles'
import { makeStyles, createStyles } from '@mui/styles'
import { CatalogList } from '@components/organisms/CatalogList'
import { CatalogFragment, OrderBy, useGetRelateCatalogsQuery } from '@services/cloud/client'

type Props = {
  catalog: CatalogFragment
}

export function RelateCatalogs(props: Props) {
  const classes = useStyles()
  const { data, loading } = useGetRelateCatalogsQuery({
    variables: {
      args: {
        limit: 8,
        skip: 0,
        orderBy: OrderBy.Desc,
        where: {
          companyId: props.catalog.companyId,
        },
      },
    },
  })

  if (loading) {
    return null
  }

  if ((data?.catalogsRelate || []).length <= 0) {
    return null
  }

  const filteredCatalogs = data?.catalogsRelate.filter(
    (catalog) => catalog?.catalogId !== props.catalog.catalogId,
  )

  return (
    <>
      {filteredCatalogs && Array.isArray(filteredCatalogs) && filteredCatalogs.length > 0 && (
        <Box pt={1}>
          <Typography className={classes.title} variant="h6">
            関連するカタログ
          </Typography>
          <Grid container={true} item={true} spacing={1}>
            {filteredCatalogs.map((catalog) => (
              <Grid key={catalog?.catalogId} item={true} xs={6} sm={3} md={3}>
                <CatalogList catalog={catalog} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(4),
    },
    title: {
      fontWeight: 550,
    },
  }),
)
